import React from 'react';
import PropTypes from 'prop-types';


const IconExpandAll = ({ width = '14px', height = '12px' }) => {
    return <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M1 6H9V8H1V6ZM1 11.5H9V9.5H1V11.5ZM1 15H9V13H1V15ZM1 4H15V1H1V4ZM15 14H13.23C14.31 13.16 15 11.9 15 10.5C15 8.28 13.28 6.42 11 6V7.42C12.44 7.82 13.5 9.05 13.5 10.5C13.5 11.59 12.9 12.55 12 13.13V10.9H11V15H15V14Z' fill='#696969' />
    </svg>;
};

IconExpandAll.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconExpandAll;
